import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthContext';
import { featureForPath, hasPlanFeature } from '@/shared/billing/planCatalog';
import { ORG_HOME_PATH } from '@/shared/layout/nav/rails';

/** Blocks typed URLs for modules outside the organization plan. API remains the real gate. */
const PlanFeatureGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();
  const feature = featureForPath(location.pathname);

  if (
    feature &&
    user?.role !== 'super_admin' &&
    user?.entitlements &&
    !hasPlanFeature(user.entitlements, feature)
  ) {
    return <Navigate to={ORG_HOME_PATH} replace />;
  }

  return <>{children}</>;
};

export default PlanFeatureGate;
